import React from 'react'
import { useLocation } from 'react-router-dom'
import InternationalizedFormattedText from '../util/internationalized-formatted-text'
import { translateError } from '../util/utils'
import { useIntl } from 'react-intl'
import errorImage from '../theme/images/error/error.svg'
import { ERROR_CODE_GENERIC_OAUTH_STRING } from '../../utils/constants'

const ErrorPage = ({ classes }) => {
  const location = useLocation()
  const urlParams = new URLSearchParams(location.search)
  const errorId = urlParams.get('error')
  const errorDescription = decodeURIComponent(urlParams.get('error_description') || '')
  const intl = useIntl()

  return (
    <>
      <div className={classes.leftAlignText}>
        <img id='errorImage' alt='errorImage' src={errorImage} className={classes.errorImage} />
        <div className={classes.textMargin}>
          <InternationalizedFormattedText
            variant='h2'
            id={intl.formatMessage({ id: 'error' }) + ' ' + errorId}
            className={classes.inlineText}
          />
        </div>
        <div className={classes.textMargin}>
          <InternationalizedFormattedText
            variant='h4'
            id={!!errorDescription ? errorDescription : translateError(errorId, ERROR_CODE_GENERIC_OAUTH_STRING)}
            className={classes.inlineText}
          />
        </div>
      </div>
    </>
  )
}

export default ErrorPage
